/*
visitorのセミナー申込画面
*/
export function seminerApplication() {
    confirmBtn();
}
function confirmBtn() {
    // 確認画面ボタン、各セミナーチェックボックスを取得
    const submit = document.getElementById("submit");
    const checkBoxs = document.querySelectorAll('[id^="check-box-"]');
    // チェックボックスが1つでも押されていれば確認画面ボタンを活性化
    for (const checkBox of checkBoxs) {
        checkBox.addEventListener("click", function () {
            if (submit.disabled === true) {
                submit.removeAttribute("disabled");
            }
        });
    }
}
